export const qtdTotalDepentes = dependentes => {
    const qtdDependentes = dependentes.length;

    return qtdDependentes;
};

export const validatorParentescoEmDuplicidade = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificaSeJaPossuiParentescoSelecionado(dependentes, valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificaSeJaPossuiParentescoSelecionado = (dependentes, values) => {
    const seq = values.Seq;
    const parentesco = values.Parentesco;
    const parentescosQuePodemSerMaisQueUm = ['5', '50', '03', '07', '10006', '10016', '22', '12', '20', '19', '24', '32'];

    if (!parentesco) {
        return false;
    }

    if (parentescosQuePodemSerMaisQueUm.includes(parentesco.trim())) {
        return false;
    }

    const possuiParentescoSelecionado = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === parentesco.trim());

    if (!possuiParentescoSelecionado.length) {
        return false;
    }

    if (seq) {
        return seq !== possuiParentescoSelecionado[0].Seq;
    }

    return true;
};

const parentescos = {
    '01': 'PAI',
    '20008': 'PADRASTO',
    '02': 'MAE',
    '20007': 'MADRASTA',
    '10': 'ESPOSO(A)',
    '15': 'SOGRO(A)',
    '5': 'FILHO(A)',
    '50': 'FILHO(A) ADOTIVO',
    '03': 'IRMA(O)',
    '07': 'SOBRINHO(A)',
    '10006': 'ENTEADO(A)',
    '10016': 'OUTROS',
    '12': 'NETO(A)',
    '22': 'PRIMO(A)',
    '19': 'GENRO',
    '20': 'NORA',
    '24': 'TIO(A)',
    'AVô': 'AVO'
};

export const retornaLabelDoValorParentesco = valueParentesco => {
    const parentesco = valueParentesco.trim();

    if (parentesco === '15') {
        return `Só é permitido dois dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    if (parentesco === 'AVô') {
        return `Só é permitido quatro dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    return `Só é permitido um dependente do tipo  ${parentescos[`${parentesco}`]}`;
};

export const validarQuantidadePet = (dependentes, parentesco) => {
    const maximoDependentesPet = 1;
    const numeroDependentesPet = dependentes.filter(dependente => dependente['GrauParentesco.Grau']?.trim() === 'PET').length;

    return numeroDependentesPet >= maximoDependentesPet && parentesco && parentesco.trim() === 'PET';
};

export const comparaRegrasDepAtuaisComDepUpSell = (dependentes, subGrupoSelecionadoUpSell) => {
    const qtdTotalDependentes = qtdTotalDepentes(dependentes);

    if (qtdTotalDependentes > 5) {
        return 'O plano ZELO IDEAL permite apenas 5 dependentes. Por favor, remova os dependentes excedentes para continuar';
    }

    for (const dep of dependentes) {
        const categoria = dep['CategoriaParentesco.Categoria'] ?? dep.Categoria;

        const mensagensErro = {
            categoriaNaoPermitida: `O dependente com a sequência ${dep.Seq} possui uma categoria inválida (${categoria}) para o plano ${subGrupoSelecionadoUpSell}. Por favor, edite ou remova o dependente para continuar.`
        };

        const categoriasPermitidas = ['ZELO', 'ZPETL'];

        if (!categoriasPermitidas.includes(categoria)) {
            return mensagensErro.categoriaNaoPermitida;
        }
    }
};